const toRound = (num: number, decimalCount: number = 2) => Math.round((num + Number.EPSILON) * Math.pow(10, decimalCount)) / Math.pow(10, decimalCount);

export default toRound;
